import React from "react";
import { Check, Star } from "lucide-react";

const PLANS = [
  {
    id: "per_case",
    name: "Pay-per-case",
    price: "₹999",
    period: "one-time",
    tag: "First case",
    desc: "Recover a single stuck invoice, end to end.",
    features: ["1 case file", "Statutory interest engine", "1 demand notice (PDF + email)", "Evidence scoring", "Samadhaan guidance"],
    highlight: false,
  },
  {
    id: "growth",
    name: "Growth",
    price: "₹1,499",
    period: "/ month",
    tag: "Most popular",
    desc: "For MSMEs with recurring collection pain.",
    features: ["Unlimited case files", "3 demand notices / month", "Priority interest updates", "Case timeline & reminders", "Email delivery receipts"],
    highlight: true,
  },
  {
    id: "unlimited",
    name: "Unlimited",
    price: "₹4,999",
    period: "/ month",
    tag: "Legal Desk",
    desc: "Full recovery ops with advocate priority.",
    features: ["Everything in Growth", "Unlimited demand notices", "Legal Desk priority access", "Advocate engagement flow", "Dedicated case manager"],
    highlight: false,
  },
];

export const Pricing = ({ onSelect }) => (
  <section id="pricing" className="border-b border-border bg-paper">
    <div className="max-w-6xl mx-auto px-6 py-24">
      <div className="max-w-2xl">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-signal">Pricing</span>
        <h2 className="mt-3 font-serif text-4xl font-semibold tracking-tight text-ink">
          Cheaper than the interest you're losing
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
          Start with one case, then scale. Waitlist members lock founding pricing.
          Prices are indicative for Phase 1 and will be confirmed at launch.
        </p>
      </div>

      <div className="mt-14 grid md:grid-cols-3 border-t border-l border-border">
        {PLANS.map((p) => (
          <div
            key={p.id}
            data-testid={`plan-${p.id}`}
            className={`relative border-r border-b border-border p-8 bg-white flex flex-col ${
              p.highlight ? "ring-2 ring-signal ring-inset z-10" : ""
            }`}
          >
            {p.highlight && (
              <span className="absolute -top-px right-6 -translate-y-1/2 inline-flex items-center gap-1 bg-signal text-white font-mono text-[10px] uppercase tracking-wider px-2.5 py-1">
                <Star className="h-3 w-3 fill-white" strokeWidth={0} /> {p.tag}
              </span>
            )}
            {!p.highlight && (
              <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-muted-foreground">
                {p.tag}
              </span>
            )}
            <h3 className="mt-3 font-serif text-3xl font-semibold text-ink">{p.name}</h3>
            <div className="mt-3 flex items-end gap-1.5">
              <span className="font-mono text-4xl font-semibold text-ink">{p.price}</span>
              <span className="text-sm text-muted-foreground mb-1">{p.period}</span>
            </div>
            <p className="mt-3 text-[13px] text-muted-foreground">{p.desc}</p>
            <ul className="mt-6 space-y-2.5 flex-1">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-sm text-ink">
                  <Check className="h-4 w-4 text-signal mt-0.5 shrink-0" strokeWidth={2} />
                  {f}
                </li>
              ))}
            </ul>
            <button
              data-testid={`plan-cta-${p.id}`}
              onClick={() => onSelect(p.id)}
              className={`mt-7 w-full py-3 text-sm font-medium transition-transform duration-150 hover:-translate-y-[1px] ${
                p.highlight
                  ? "bg-signal text-white hover:bg-signal-dark"
                  : "bg-white text-ink border border-ink hover:bg-ink hover:text-white"
              }`}
            >
              Join waitlist for {p.name}
            </button>
          </div>
        ))}
      </div>
    </div>
  </section>
);
